import { FC, useState } from 'react';
import { VStack } from '@chakra-ui/react';

import { useBankDetailsEdition } from 'common/hooks/useBankDetailsEdition';
import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import BackButton from 'components/BackButton';
import StepperProgressBar from 'components/Stepper/StepperProgressBar';
import { StepProps } from 'components/Stepper/types';
import { UserBankDetailsForm } from 'components/UserBankDetailsForm';
import * as Layout from 'layouts/StickyStepperLayout';

import { useNewExpenseClaimRequestState } from '../../../NewExpenseClaimRequestProvider';
import locales from './locales';

const FORM_NAME = 'RecipientInformationForm';

export const RecipientInformation: FC<StepProps> = ({ goBack, goNext }) => {
  const [isValid, setIsValid] = useState(false);
  const { saveBankDetails, saving } = useBankDetailsEdition();
  const { dispatch, recipientInformation, shouldSkipRecipientInformation } =
    useNewExpenseClaimRequestState();

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer>
          <BackButton onClick={goBack} />
        </Layout.HeaderButtonsContainer>
        <Layout.ContentsContainer gap="space-40">
          <VStack align="flex-start" spacing="space-16">
            <Heading size="lg">{locales.title}</Heading>
            <Text size="lg">{locales.description}</Text>
          </VStack>
          <UserBankDetailsForm
            defaultValues={recipientInformation}
            disabled={saving}
            id={FORM_NAME}
            onSubmit={async (data) => {
              await saveBankDetails({
                iban: data.iban,
                recipientName: data.name,
                swiftBic: data.swiftBic,
              });
              dispatch({
                payload: data,
                type: 'SUBMIT_RECIPIENT_INFORMATION',
              });
              goNext({
                key: 'transfer-overview',
              });
            }}
            onValidStateChanged={setIsValid}
          />
          {!shouldSkipRecipientInformation ? (
            <Callout variant="info">
              <Callout.Content>{locales.ibanProfileCallout}</Callout.Content>
            </Callout>
          ) : null}
        </Layout.ContentsContainer>
        <Layout.FooterContainer>
          <StepperProgressBar />

          <Layout.FooterButtonsContainer>
            <Button
              form={FORM_NAME}
              isDisabled={!isValid}
              isLoading={saving}
              type="submit"
            >
              {locales.submit}
            </Button>
          </Layout.FooterButtonsContainer>
        </Layout.FooterContainer>
      </Layout.Body>
    </Layout.Root>
  );
};
